; (function ($, window, document, undefined) {

    var pluginName = "radio",
        defaults = {
            elemRadioClass       : "",         // Détermine la classe de l'élément HTML à modifier
            baseClass            : "",         // Permet de définir le sprite utilisé
            radioClass           : "radio",    // Permet d'ajouter la classe qui positionne le sprite
            classON              : "active",   // Position sprite button ON
            classOFF             : "inactive", // Position sprite button OFF
            classInactive        : "disabled", // Position sprite button OFF
            addClass             : "",         // Si besoin d'ajouter une classe CSS sur le radioButton
            callback_after_click : function () { } // Méthode rappelée aprés un click sur le bouton radio
        };

    function Plugin(element, options) {
        this.element = element;
        this.type;
        this.options = $.extend({}, defaults, options);
        this.radio = $("." + this.options.elemRadioClass, this.element);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    Plugin.prototype = {
        init: function () {
            var type, input;
            type = this.controlTypeTag();
            input = this.radio;

            switch (type) {
                case "a": // Balise de type </a>
                    this.prepareA(); // Nettoie le texte inclu dans le lien
                    break;

                case "input": // Balise de type <input type="radio" /> ou <input type="checkbox" />
                    this.replaceInputByA() // Génère une balise </a> pour contrôler l'input radio
                    this.bindEventForInput(); // modifie la valeur de l'</input> lorsqu'on clique sur le </a>
                    break;

                default:
                    break;
            }
        },
        controlTypeTag: function () { // controle le type de balise utilisée
            if (this.radio.length) {
                this.type = this.radio.prop('type');
                return this.radio.get(0).tagName.toLowerCase();
            } else {
                this.addAelement();
                $("." + this.options.elemRadioClass, this.element).addClass(this.options.classON);
                return "a";
            }
        },
        addClassOnRadioA: function () { // on ajoute les classes CSS permettant l'affichage correct du a
            this.radio.addClass(this.options.baseClass + ' ' + this.options.radioClass);
        },
        prepareA: function () { // Préparation de la balise </a> pour accueillir les éléments
            this.radio.text("");
            this.addClassOnRadioA();
        },
        replaceInputByA: function () { // remplacement et pilotage de l'input
            this.radio.addClass("input hide");
            this.addAelement();
            if (this.radio.prop("checked"))
                $("." + this.options.elemRadioClass, this.element).addClass("active");
        },
        addAelement: function () { // On ajoute l'élément html de remplacement

            //if (!$(".input", this.element).prop("disabled")) // on vérifie qu'il n'est pas volontairement désactivé
                $(this.element).prepend('<a href="#" class="' + this.options.elemRadioClass + ' ' + this.options.baseClass + ' ' + this.options.radioClass + '" data-name="' + this.radio.prop('name') + '"><!-- --></a>');
            //else

        },
        bindEventForInput: function () {
            var classSearch, radioGroupName, typeOfInput, anchor, input, plugin, checkDisabled;
                plugin = this;
                classSearch = this.options.radioClass;
                typeOfInput = this.type;
                anchor = $("a." + classSearch, this.element);
                input = anchor.next();
                checkDisabled = this.radio.is(":disabled");

            if (!checkDisabled) {

                anchor.on(
                    "click",
                    function (e) {
                        e.preventDefault();

                        if (typeOfInput === "radio") {
                            input.prop('checked', true);
                        }

                        input.click(); // click on radioButton
                    }
                );

                input.on('click', function () {
                    $("a." + classSearch + (anchor.data('name') != '' ? '[data-name="' + anchor.data('name') + '"]' : '')).each(function () {
                        if (typeOfInput === "radio") {
                            if ($(this).hasClass("active")) $(this).removeClass("active");
                        }
                    });
                    anchor.toggleClass("active");
                    plugin.options.callback_after_click(plugin, plugin.radio);
                });

            } else {
                anchor.addClass(this.options.classInactive);
                anchor.on('click', function (e) {
                    e.preventDefault();
                });
            }

        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
